import React from "react";

var orderSvg = function orderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.43 6l-.328 1.224a3 3 0 0 0 5.796 1.552L11.642 6H15a1 1 0 0 1 0 2l-.901 7.11a1 1 0 0 1-.994.89H2.895a1 1 0 0 1-.994-.89L1 8a1 1 0 1 1 0-2zM9.03.291a.5.5 0 0 1 .584-.274l.965.258a.499.499 0 0 1 .354.612L9.568 6h.003l-.605 2.259a1 1 0 0 1-1.932-.518z",
    fillRule: "evenodd"
  }));
};

orderSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var order = {
  category: 'icon',
  colorable: true,
  name: 'order',
  svg: orderSvg
};